import PhotoGalleryBlock from './PhotoGalleryBlock';

export default PhotoGalleryBlock;
